import React from 'react';
import { Link } from 'react-router-dom';
import RightArrowIcon from 'app/components/icons/RightArrowIcon';
import UnreadMessagesBadge from 'app/components/UnreadMessagesBadge';
import OstroDynamicContent from 'app/components/OstroDynamicContent';

interface TailorLiveChatModuleUnityProps {
  className?: string;
  icon?: string;
  title?: string;
  description?: string;
  caption?: string;
  unreadMessageCount: number;
  onClick: () => void;
  backgroundColor: string;
  isOnline?: boolean;
  statusText?: string;
}

export const TailorLiveChatModuleUnity = ({
  className,
  icon,
  title,
  description,
  caption,
  unreadMessageCount,
  onClick,
  backgroundColor,
  isOnline,
  statusText,
}: TailorLiveChatModuleUnityProps) => {
  return (
    <div
      className={className}
      id="ostro-tailor-live-chat-module-unity"
    >
      <Link
        to="/live-chat"
        className="flex items-center gap-4 rounded-lg p-4 text-left w-full"
        style={{ backgroundColor }}
        onClick={onClick}
      >
        <div className="w-6 relative shrink-0 self-start">
          {icon && (
            <img
              className="block w-6 h-6"
              src={icon}
              alt={title}
            />
          )}
          {unreadMessageCount > 0 && (
            <UnreadMessagesBadge
              count={unreadMessageCount}
              size="sm"
              className="top-[-5px] right-[-5px]"
            />
          )}
        </div>
        <div className="grow">
          <OstroDynamicContent
            content={title}
            className="font-medium text-gray-900"
          />
          {statusText && (
            <div className="flex items-center gap-2 mt-1">
              <div className={`w-2 h-2 rounded-full ${isOnline ? 'bg-status-green' : 'bg-status-red'}`}></div>
              <span
                className="text-xs text-gray-600"
                dangerouslySetInnerHTML={{ __html: statusText }}
              />
            </div>
          )}
          {description && (
            <OstroDynamicContent
              content={description}
              className="text-xs text-gray-600 mt-1"
            />
          )}
          {!!caption && (
            <div className="mt-2 py-1 px-2 text-[10px] bg-brand-primary rounded-2xl whitespace-nowrap inline-block text-white">
              {caption}
            </div>
          )}
        </div>
        <div className="w-6 self-center">
          <RightArrowIcon className="w-6 h-6 text-black" />
        </div>
      </Link>
    </div>
  );
};
